import React, { type ReactElement } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAppSelector } from 'store/hooks'
import { type Role } from 'common/utils/types'

interface RequireRolesProps {
  allowedRoles: Role[]
}

const RequireRoles: React.FC<RequireRolesProps> = ({ allowedRoles }): ReactElement => {
  const { isAuthenticated, userInfo } = useAppSelector((state) => state.auth)
  if (isAuthenticated && userInfo?.role && allowedRoles.includes(userInfo?.role)) {
    return <Outlet />
  }
  if (userInfo?.isVendor) {
    return <Outlet />
  }
  return <Navigate to={{ pathname: '/' }} replace />
}

export default RequireRoles
